import GLightbox from 'glightbox'

const lightbox = GLightbox({
    touchNavigation: true,
    loop: true,
    draggable: true,
    autoplayVideos: true
});